var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgThaettir = function SvgThaettir(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#thaettir_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7 29a50.289 50.289 0 0 1 9-1c3.024.062 6.036.397 9 1M16 24v4M30 3H2a1 1 0 0 0-1 1v19a1 1 0 0 0 1 1h28a1 1 0 0 0 1-1V4a1 1 0 0 0-1-1Z",
    stroke: "#fff",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 21a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z",
    fill: "#fff"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "thaettir_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h32v32H0z"
  })))));
};
export default SvgThaettir;